<svelte:options runes={false} />
<script>
  import { createEventDispatcher } from 'svelte';
  import { strategies } from '../../lib/strategies.js';

  const dispatch = createEventDispatcher();

  // One-way prop from the form: the selected StrategyType int. Selection changes are reported back via the
  // `select` event (not a two-way `bind:`) — an assignment in the form's event handler is reactive across
  // Svelte versions, whereas a child-reassigned bound prop does not reliably re-trigger the parent's
  // reactive statements / prop flow-down in Svelte 5.
  export let selectedId = strategies[0].id;

  // The strategy whose "How it works" detail is shown in the overlay (null = closed). Opening the overlay
  // does NOT change the selection — it's a read-only explainer — so the grid never reflows.
  let detailStrategy = null;

  function select(id) {
    dispatch('select', id);
  }

  function openDetail(strategy, event) {
    event.stopPropagation(); // don't trigger card selection
    detailStrategy = strategy;
  }

  function closeDetail() {
    detailStrategy = null;
  }

  function onOverlayKeydown(event) {
    if (event.key === 'Escape') {
      closeDetail();
    }
  }
</script>

<svelte:window on:keydown={detailStrategy ? onOverlayKeydown : undefined} />

<div class="strategy-picker">
  <span id="strategy-picker-label" class="form-label">Strategy</span>
  <div class="strategy-grid" role="radiogroup" aria-labelledby="strategy-picker-label">
    {#each strategies as strategy (strategy.id)}
      <div class="strategy-card" class:selected={selectedId === strategy.id}>
        <button
          type="button"
          class="strategy-card-main"
          role="radio"
          aria-checked={selectedId === strategy.id}
          on:click={() => select(strategy.id)}
        >
          <span class="strategy-name">{strategy.name}</span>
          <span class="strategy-blurb">{strategy.blurb}</span>
          <span class="strategy-when">{strategy.when}</span>
        </button>

        <button
          type="button"
          class="strategy-explain-toggle"
          aria-haspopup="dialog"
          on:click={(e) => openDetail(strategy, e)}
        >
          How it works
        </button>
      </div>
    {/each}
  </div>
</div>

{#if detailStrategy}
  <!-- Inline overlay: a centered dialog over a dimmed backdrop. Keeps the grid stable (no row reflow). -->
  <div
    class="strategy-detail-overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="strategy-detail-title"
    tabindex="-1"
    on:click|self={closeDetail}
    on:keydown={onOverlayKeydown}
  >
    <div class="strategy-detail-dialog">
      <div class="strategy-detail-dialog-head">
        <h3 id="strategy-detail-title" class="strategy-detail-dialog-title">{detailStrategy.name}</h3>
        <button type="button" class="strategy-detail-close" aria-label="Close" on:click={closeDetail}>×</button>
      </div>
      <p class="strategy-detail-when">{detailStrategy.when}</p>
      <p class="strategy-detail-body">{detailStrategy.detail}</p>
      <div class="strategy-detail-actions">
        {#if selectedId !== detailStrategy.id}
          <button type="button" class="btn btn-primary btn-sm"
            on:click={() => { select(detailStrategy.id); closeDetail(); }}>Use this strategy</button>
        {/if}
        <button type="button" class="btn btn-ghost btn-sm" on:click={closeDetail}>Close</button>
      </div>
    </div>
  </div>
{/if}

<style>
  @import './StrategyPicker.css';
</style>